import { render } from "./BlogSidebar.vue?vue&type=template&id=5757255b"
import script from "./BlogSidebar.vue?vue&type=script&lang=js"
export * from "./BlogSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__